'use client';

import { createPortal } from 'react-dom';
import { useIsClient } from '../../headless/useIsClient/useIsClient';
import { AppSpinner } from '../AppSpinner/AppSpinner';

/**
 * Blocks the screen with a spinner while a request is in flight.
 *
 * Portalled to the body because `position: fixed` resolves against an ancestor
 * with a transform or filter, which would leave the app bar uncovered.
 * `touch-none` stops a phone rubber-banding the page underneath.
 *
 * `useIsClient` keeps the portal off the server.
 *
 * `z-60` sits above dialogs and the toast, since it blocks everything; only
 * the tooltip is higher. `dialogClasses` has the scale.
 */
export function Backdrop({ open }: { open: boolean }) {
  const isClient = useIsClient();

  if (!open || !isClient) return undefined;

  return createPortal(
    <div
      aria-busy
      aria-label='loading'
      className='fixed inset-0 z-60 flex touch-none items-center justify-center bg-foreground/50'
    >
      <AppSpinner className='text-white' />
    </div>,
    document.body,
  );
}
